import { TICKETING_CATALOGUE_ID } from "@/features/boutique/services/ticketing.service";
import type { AutocompleteResponse } from "@/features/shop/types/autocomplete.types";
import { fetcher } from "@/shared/lib/fetcher.client";

type AutocompleteSearchParams = { catalogueId?: number };

const getAutocompleteEndpoint = (catalogueId?: number): string => {
  if (catalogueId === TICKETING_CATALOGUE_ID) {
    return `/rce-catalogues/${catalogueId}/events/autocomplete`;
  }
  return "/shop/autocomplete";
};

export const autocompleteService = {
  search: async (query: string, params?: AutocompleteSearchParams): Promise<AutocompleteResponse> => {
    const endpoint = getAutocompleteEndpoint(params?.catalogueId);
    const response = await fetcher.get<AutocompleteResponse>(
      endpoint,
      {
        params: {
          q: query,
          ...(params?.catalogueId !== undefined && params.catalogueId !== TICKETING_CATALOGUE_ID && { catalogue_id: params.catalogueId }),
        },
      },
    );
    return response.data;
  },
};
